import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Shield } from "lucide-react";

export function LegalFooter({ className = "", enableVotMaAlcada, enableAudit, enableVoterTracking }) {
  const { t } = useTranslation();

  let footerKey = "legal.footerText";
  if (enableVotMaAlcada) footerKey = "legal.footerTextHandVote";
  else if (enableAudit || enableVoterTracking) footerKey = "legal.footerTextTracking";

  return (
    <footer className={`border-t border-slate-200 dark:border-slate-700 mt-auto ${className}`} data-testid="legal-footer">
      <div className="max-w-5xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center gap-2 text-xs text-slate-500 dark:text-slate-400">
        <Shield className="h-3.5 w-3.5 shrink-0 text-slate-400" />
        <p className="text-center sm:text-left leading-relaxed">
          {t(footerKey)}{" "}
          <Link to="/legal" className="underline hover:text-slate-700 dark:hover:text-slate-200" data-testid="legal-link">
            {t("legal.footerLink")}
          </Link>
        </p>
      </div>
    </footer>
  );
}

export function LegalFooterDark() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-slate-700 mt-auto" data-testid="legal-footer">
      <div className="max-w-5xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center gap-2 text-xs text-slate-500">
        <Shield className="h-3.5 w-3.5 shrink-0 text-slate-600" />
        <p className="text-center sm:text-left leading-relaxed">
          {t("legal.footerText")}{" "}
          <Link to="/legal" className="underline hover:text-slate-300" data-testid="legal-link">
            {t("legal.footerLink")}
          </Link>
        </p>
      </div>
    </footer>
  );
}
